<template>
    <el-dropdown @command="langChange" trigger="click" v-if="componentShow">
      <span class="el-dropdown-link" style="cursor: pointer;" :style="{color: color}">
        {{languageName}}
        <img style="margin-bottom: 3px;margin-left:4px;" src="../../assets/icon/down.png" v-if="color == '#fff'"/>
        <img style="margin-bottom: 3px;margin-left:4px;" src="../../assets/icon/down1.png" v-else />
      </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in lang"
                              :key="index"
                              :command="item.value"
                              :disabled="language===item.value">
                {{item.name}}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
    import {mapGetters} from 'vuex'
    export default {
        computed: {
            ...mapGetters(['lang']),
            language() {
                return this.$store.getters.language
            },
            languageName() {
                return this.$store.getters.languageName
            }
        },
        props: {
            color: {
                type: String,
                default: '#fff'
            }
        },
        data(){
            return {
                componentShow:true
            }
        },
        methods: {
            langChange(lang) {
                this.$router.go()
                this.$i18n.locale = lang;
                this.$store.dispatch('setLanguage', lang);
                this.$message({
                    message: this.$t('hint.switchLanguageSuccess'),
                    type: 'success'
                })
            },
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/language/index.vue